import { TabsContent, FormField } from '@/components/molecules';
import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms';
import { useForm, Controller } from 'react-hook-form';
import { useEffect } from 'react';
import { useUser, useUpdateUser } from '@/api';
import { timezones, dateFormats } from '@/lib/constants';
import type { Theme, DateFormat } from '@/types';

interface PreferencesFormData {
  theme: Theme;
  timezone: string;
  dateFormat: DateFormat;
}

export const PreferencesTab = () => {
  const { data: user } = useUser('me');
  const { mutate: updateUser, isPending } = useUpdateUser(
    user?.id?.toString() || 'me'
  );

  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    setValue,
  } = useForm<PreferencesFormData>({
    defaultValues: {
      theme: 'light',
      timezone: 'UTC',
      dateFormat: 'DD/MM/YYYY',
    },
  });

  useEffect(() => {
    if (user?.settings) {
      setValue('theme', user.settings.theme || 'light');
      setValue('dateFormat', user.settings.dateFormat || 'DD/MM/YYYY');
      setValue('timezone', user.settings.timezone || 'UTC');
    }
  }, [user, setValue]);

  const onSubmit = (data: PreferencesFormData) => {
    updateUser({
      settings: {
        theme: data.theme,
        dateFormat: data.dateFormat,
        timezone: data.timezone,
      },
    });
  };

  return (
    <TabsContent value="preferences">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-6 max-w-xl mx-auto py-6"
      >
        <div className="flex flex-col gap-6">
          {/* <FormField label="Select Theme" error={errors.theme?.message}>
            <Controller
              name="theme"
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select theme" />
                  </SelectTrigger>
                  <SelectContent>
                    {themes.map((theme) => (
                      <SelectItem key={theme.value} value={theme.value}>
                        {theme.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
          </FormField> */}

          <FormField label="Time Zone" error={errors.timezone?.message}>
            <Controller
              name="timezone"
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select timezone" />
                  </SelectTrigger>
                  <SelectContent>
                    {timezones.map((timezone) => (
                      <SelectItem key={timezone.value} value={timezone.value}>
                        {timezone.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
          </FormField>

          <FormField label="Date" error={errors.dateFormat?.message}>
            <Controller
              name="dateFormat"
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select date format" />
                  </SelectTrigger>
                  <SelectContent>
                    {dateFormats.map((format) => (
                      <SelectItem key={format.value} value={format.value}>
                        {format.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
          </FormField>
        </div>

        <Button
          className="w-full"
          label="Save"
          size="lg"
          type="submit"
          isLoading={isPending}
          disabled={!isDirty}
        />
      </form>
    </TabsContent>
  );
};
